"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));
var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
/**
 * 언더바가 붙은 함수 및 변수를 외부에서 쓰지 마세요
 * @author extracold1209, wodnjs6512
 */

var _require = require('./audioSocket'),
  voiceApiConnect = _require.voiceApiConnect;
var toWav = require('audiobuffer-to-wav');
var STATUS_CODE = {
  CONNECTED: 'CONNECTED',
  NOT_RECOGNIZED: 'NOT_RECOGNIZED',
  START_RECOGNIZE: 'START_RECOGNIZE',
  END_POINT_DETECTED: 'END_POINT_DETECTED'
};
var getVoiceServerAddress = function getVoiceServerAddress() {
  return {
    hostname: Entry.baseUrl,
    path: '/vc'
  };
};
var DESIRED_SAMPLE_RATE = 16000;
var AudioUtils = /*#__PURE__*/function () {
  function AudioUtils() {
    var _this = this;
    (0, _classCallCheck2["default"])(this, AudioUtils);
    (0, _defineProperty2["default"])(this, "isTimedRecord", false);
    (0, _defineProperty2["default"])(this, "timedResult", []);
    (0, _defineProperty2["default"])(this, "stopCallback", null);
    (0, _defineProperty2["default"])(this, "_handleScriptProcess", function (analyserNode) {
      return function (audioProcessingEvent) {
        var array = new Uint8Array(analyserNode.frequencyBinCount);
        analyserNode.getByteFrequencyData(array);

        // 현재 input 의 볼륨세기
        _this._currentVolume = array.reduce(function (total, data) {
          return total + data;
        }, 0) / array.length;

        // 볼륨 변형 없이 그대로 통과
        var inputBuffer = audioProcessingEvent.inputBuffer,
          outputBuffer = audioProcessingEvent.outputBuffer;
        for (var channel = 0; channel < outputBuffer.numberOfChannels; channel++) {
          var inputData = inputBuffer.getChannelData(channel);
          var outputData = outputBuffer.getChannelData(channel);
          for (var sample = 0; sample < inputBuffer.length; sample++) {
            outputData[sample] = inputData[sample];
          }
        }
        if (!_this.isRecording) {
          return;
        }

        ///// RESAMPLE
        // offline context 로 44100hz 에서 16000hz로 resample
        var offlineCtx = new OfflineAudioContext(outputBuffer.numberOfChannels, outputBuffer.duration * DESIRED_SAMPLE_RATE, DESIRED_SAMPLE_RATE);
        var cloneBuffer = offlineCtx.createBuffer(outputBuffer.numberOfChannels, outputBuffer.length, outputBuffer.sampleRate);
        // Copy the source data into the offline AudioBuffer
        for (var _channel = 0; _channel < outputBuffer.numberOfChannels; _channel++) {
          cloneBuffer.copyToChannel(outputBuffer.getChannelData(_channel), _channel);
        }
        // Play it from the beginning.
        var source = offlineCtx.createBufferSource();
        source.buffer = cloneBuffer;
        source.connect(offlineCtx.destination);
        offlineCtx.oncomplete = function (e) {
          if (!_this.isRecording) {
            return;
          }
          if (_this.isTimedRecord) {
            _this.timedResult.push(e.renderedBuffer);
          } else if (_this._socketClient && _this._socketClient.readyState === _this._socketClient.OPEN) {
            // socket.io로 서버 전송
            _this._socketClient.send(toWav(e.renderedBuffer));
          }
        };
        offlineCtx.startRendering();
        source.start(0);
      };
    });
    this.isInitialized = false; // 유저 인풋 연결 확인
    this.isRecording = false;
    this._userMediaStream = undefined;
    this._mediaRecorder = undefined;
    this._currentVolume = -1;
    this._audioChunks = [];
    this.result = null;
    this.startedRecording = false;
    this.audioInputList = [];
  }
  return (0, _createClass2["default"])(AudioUtils, [{
    key: "currentVolume",
    get: function get() {
      return this._currentVolume;
    }
  }, {
    key: "getMediaStream",
    value: function () {
      var _getMediaStream = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee() {
        var _t;
        return _regenerator["default"].wrap(function (_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.prev = 0;
              _context.next = 1;
              return navigator.mediaDevices.getUserMedia({
                audio: {
                  autoGainControl: true,
                  noiseSuppression: true,
                  echoCancellation: true
                }
              });
            case 1:
              return _context.abrupt("return", _context.sent);
            case 2:
              _context.prev = 2;
              _t = _context["catch"](0);
              // is MIC present in browser
              this.isRecording = false;
              this.stopRecord();
              throw new Entry.Utils.IncompatibleError('IncompatibleError', [Lang.Workspace.check_microphone_error]);
            case 3:
            case "end":
              return _context.stop();
          }
        }, _callee, this, [[0, 2]]);
      }));
      function getMediaStream() {
        return _getMediaStream.apply(this, arguments);
      }
      return getMediaStream;
    }()
  }, {
    key: "incompatBrowserChecker",
    value: function incompatBrowserChecker() {
      // IE/safari CHECKER
      if (!this.isAudioSupport) {
        this.isAudioSupport = this._isBrowserSupportAudio(); // 브라우저 지원 확인
        if (!this.isAudioSupport) {
          this.isRecording = false;
          this.stopRecord();
          throw new Entry.Utils.IncompatibleError('IncompatibleError', [Lang.Workspace.check_microphone_error]);
        }
      }
    }
  }, {
    key: "initialize",
    value: function () {
      var _initialize = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee2() {
        var _this2 = this;
        var mediaStream, inputList, audioContext, streamSrc, analyserNode, gainNode, highpassFilter, scriptNode, streamDest, mediaRecorder, _t2;
        return _regenerator["default"].wrap(function (_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              if (!this.isInitialized) {
                _context2.next = 1;
                break;
              }
              return _context2.abrupt("return");
            case 1:
              this.incompatBrowserChecker();
              _context2.next = 2;
              return this.getMediaStream();
            case 2:
              mediaStream = _context2.sent;
              _context2.prev = 3;
              Entry.addEventListener('beforeStop', function () {
                _this2.improperStop();
              });
              _context2.next = 4;
              return navigator.mediaDevices.enumerateDevices();
            case 4:
              inputList = _context2.sent;
              this.audioInputList = inputList.filter(function (input) {
                return input.kind === 'audioinput';
              }).map(function (item) {
                return [item.label, item.deviceId];
              });
              if (!window.AudioContext) {
                if (window.webkitAudioContext) {
                  window.AudioContext = window.webkitAudioContext;
                }
              }
              audioContext = new window.AudioContext();
              streamSrc = audioContext.createMediaStreamSource(mediaStream);
              analyserNode = audioContext.createAnalyser(); // const reducerNode = new window.audio.NoiseReducer(0.5, 5);
              gainNode = audioContext.createGain();
              gainNode.gain.value = 1.8;
              highpassFilter = audioContext.createBiquadFilter();
              highpassFilter.type = 'highpass';
              highpassFilter.frequency.value = 150;
              highpassFilter.Q.value = 1;
              highpassFilter.detune.value = 1;
              analyserNode.fftSize = 4096;
              analyserNode.smoothingTimeConstant = 0.0;
              analyserNode.minDecibels = -80;
              analyserNode.maxDecibels = -40;
              scriptNode = audioContext.createScriptProcessor(512, 1, 1);
              streamDest = audioContext.createMediaStreamDestination();
              mediaRecorder = new MediaRecorder(streamDest.stream); // 순서대로 노드 커넥션을 맺는다.
              this._connectNodes(streamSrc, analyserNode, scriptNode, streamDest);
              scriptNode.onaudioprocess = this._handleScriptProcess(analyserNode);
              this._audioContext = audioContext;
              this._userMediaStream = mediaStream;
              this._mediaRecorder = mediaRecorder;

              // 음성 인식 api 를 사용하기 위함
              // 음성 인식은 websocket 을 통해서 WAV로 전송하게 되어있음.
              // 첫번째 파라미터는 프로토콜을 제외한 hostname+port 조합
              // ex)'localhost:4001'
              this.isInitialized = true;
              return _context2.abrupt("return");
            case 5:
              _context2.prev = 5;
              _t2 = _context2["catch"](3);
              console.error('error occurred while init audio input', _t2);
              this.isInitialized = false;
              return _context2.abrupt("return");
            case 6:
            case "end":
              return _context2.stop();
          }
        }, _callee2, this, [[3, 5]]);
      }));
      function initialize() {
        return _initialize.apply(this, arguments);
      }
      return initialize;
    }()
  }, {
    key: "improperStop",
    value: function improperStop() {
      this.stopRecord();
      if (this.resolveFunc) {
        this.resolveFunc('');
      }
    }
  }, {
    key: "startRecord",
    value: function startRecord(recordMilliSecond, language) {
      var _this3 = this;
      return new Promise(/*#__PURE__*/function () {
        var _ref = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee3(resolve, reject) {
          var _t3;
          return _regenerator["default"].wrap(function (_context3) {
            while (1) switch (_context3.prev = _context3.next) {
              case 0:
                _this3.resolveFunc = resolve;
                if (_this3.isInitialized) {
                  _context3.next = 1;
                  break;
                }
                console.log('audio not initialized');
                resolve(0);
                return _context3.abrupt("return");
              case 1:
                if (!(_this3._audioContext.state === 'suspended')) {
                  _context3.next = 2;
                  break;
                }
                _this3.isInitialized = false;
                _context3.next = 2;
                return _this3.initialize();
              case 2:
                _context3.prev = 2;
                _context3.next = 3;
                return voiceApiConnect(getVoiceServerAddress(), language, function (data) {
                  _this3.result = data;
                });
              case 3:
                _this3._socketClient = _context3.sent;
                _context3.next = 5;
                break;
              case 4:
                _context3.prev = 4;
                _t3 = _context3["catch"](2);
                console.log(_t3);
              case 5:
                _this3._audioChunks = [];
                _this3._stopMediaRecorder();
                _this3._mediaRecorder.start();
                _this3.startedRecording = true;
                Entry.engine.toggleAudioShadePanel();
                _this3._socketClient.on('disconnect', function () {
                  resolve('-');
                });
                _this3._socketClient.on('message', function (e) {
                  switch (e) {
                    case STATUS_CODE.CONNECTED:
                      break;
                    case STATUS_CODE.END_POINT_DETECTED:
                      Entry.dispatchEvent('audioRecordProcessing');
                      if (_this3.startedRecording) {
                        Entry.engine.toggleAudioProgressPanel();
                      }
                      _this3.startedRecording = false;
                      break;
                    case STATUS_CODE.NOT_RECOGNIZED:
                      _this3.stopCallback = null;
                      resolve('-');
                      _this3.stopRecord();
                      break;
                    default:
                      {
                        var parsed = JSON.parse(e);
                        var isArray = Array.isArray(parsed);
                        if (isArray) {
                          _this3.stopCallback = null;
                          resolve(parsed[0]);
                          _this3.stopRecord();
                        } else {
                          resolve('-');
                        }
                        break;
                      }
                  }
                });
                _this3._properStopCall = setTimeout(_this3.stopRecord, recordMilliSecond);
                _this3.stopCallback = function () {
                  resolve(0);
                };
              case 6:
              case "end":
                return _context3.stop();
            }
          }, _callee3, null, [[2, 4]]);
        }));
        return function (_x, _x2) {
          return _ref.apply(this, arguments);
        };
      }());
    }
  }, {
    key: "startTimedRecord",
    value: function startTimedRecord(recordMilliSecond, language) {
      var _this4 = this;
      return new Promise(/*#__PURE__*/function () {
        var _ref2 = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee5(resolve, reject) {
          var _t5;
          return _regenerator["default"].wrap(function (_context5) {
            while (1) switch (_context5.prev = _context5.next) {
              case 0:
                _this4.isTimedRecord = true;
                _this4.timedResult = [];
                _this4.resolveFunc = resolve;
                if (_this4.isInitialized) {
                  _context5.next = 1;
                  break;
                }
                console.log('audio not initialized');
                resolve(0);
                return _context5.abrupt("return");
              case 1:
                if (!(_this4._audioContext.state === 'suspended')) {
                  _context5.next = 2;
                  break;
                }
                _this4.isInitialized = false;
                _context5.next = 2;
                return _this4.initialize();
              case 2:
                _context5.prev = 2;
                _context5.next = 3;
                return voiceApiConnect(getVoiceServerAddress(), language, function (data) {
                  _this4.result = data;
                });
              case 3:
                _this4._socketClient = _context5.sent;
                _context5.next = 5;
                break;
              case 4:
                _context5.prev = 4;
                _t5 = _context5["catch"](2);
                console.log(_t5);
              case 5:
                _this4._audioChunks = [];
                _this4._stopMediaRecorder();
                _this4._mediaRecorder.start();
                _this4.startedRecording = true;
                Entry.engine.toggleAudioShadePanel();
                _this4._properStopCall = setTimeout(/*#__PURE__*/(0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee4() {
                  var result, _t4;
                  return _regenerator["default"].wrap(function (_context4) {
                    while (1) switch (_context4.prev = _context4.next) {
                      case 0:
                        _context4.prev = 0;
                        _this4.isTimedRecord = false;
                        Entry.dispatchEvent('audioRecordProcessing');
                        if (_this4.startedRecording) {
                          Entry.engine.toggleAudioProgressPanel();
                        }
                        _this4.startedRecording = false;
                        _context4.next = 1;
                        return _this4.sendBuffer(_this4.timedResult, language);
                      case 1:
                        result = _context4.sent;
                        _this4.stopRecord();
                        resolve(result);
                        _context4.next = 3;
                        break;
                      case 2:
                        _context4.prev = 2;
                        _t4 = _context4["catch"](0);
                        resolve(0);
                      case 3:
                      case "end":
                        return _context4.stop();
                    }
                  }, _callee4, null, [[0, 2]]);
                })), recordMilliSecond);
                _this4.stopCallback = function () {
                  resolve(0);
                };
              case 6:
              case "end":
                return _context5.stop();
            }
          }, _callee5, null, [[2, 4]]);
        }));
        return function (_x3, _x4) {
          return _ref2.apply(this, arguments);
        };
      }());
    }
  }, {
    key: "sendBuffer",
    value: function () {
      var _sendBuffer = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee7(buffers, language) {
        var _this5 = this;
        return _regenerator["default"].wrap(function (_context7) {
          while (1) switch (_context7.prev = _context7.next) {
            case 0:
              return _context7.abrupt("return", new Promise(/*#__PURE__*/function () {
                var _ref4 = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee6(resolve, reject) {
                  return _regenerator["default"].wrap(function (_context6) {
                    while (1) switch (_context6.prev = _context6.next) {
                      case 0:
                        _this5._socketClient.on('disconnect', function () {
                          resolve('-');
                        });
                        _this5._socketClient.on('message', function (e) {
                          switch (e) {
                            case STATUS_CODE.CONNECTED:
                              break;
                            case STATUS_CODE.END_POINT_DETECTED:
                              break;
                            case STATUS_CODE.NOT_RECOGNIZED:
                              _this5.stopCallback = null;
                              resolve('-');
                              _this5.stopRecord();
                              break;
                            default:
                              {
                                var parsed = JSON.parse(e);
                                var isArray = Array.isArray(parsed);
                                if (isArray) {
                                  _this5.stopCallback = null;
                                  resolve(parsed[0]);
                                  _this5.stopRecord();
                                } else {
                                  resolve('-');
                                }
                                break;
                              }
                          }
                        });
                        if (_this5._socketClient && _this5._socketClient.readyState === _this5._socketClient.OPEN) {
                          // socket.io로 서버 전송
                          buffers.forEach(function (buffer) {
                            _this5._socketClient.send(toWav(buffer));
                          });
                        }
                      case 1:
                      case "end":
                        return _context6.stop();
                    }
                  }, _callee6);
                }));
                return function (_x7, _x8) {
                  return _ref4.apply(this, arguments);
                };
              }()));
            case 1:
            case "end":
              return _context7.stop();
          }
        }, _callee7);
      }));
      function sendBuffer(_x5, _x6) {
        return _sendBuffer.apply(this, arguments);
      }
      return sendBuffer;
    }()
  }, {
    key: "_stopMediaRecorder",
    value: function _stopMediaRecorder() {
      if (this._mediaRecorder.state == 'recording' || this._mediaRecorder.state === 'paused') {
        this._mediaRecorder.stop();
      }
    }

    /**
     * 녹음을 종료한다.
     */
  }, {
    key: "stopRecord",
    value: function stopRecord() {
      var _this$stream;
      if (this._socketClient) {
        this._socketClient.disconnect();
      }
      if (!this.isInitialized || !this.isRecording) {
        return;
      }
      Entry.dispatchEvent('audioRecordProcessing');
      if (this.startedRecording) {
        Entry.engine.toggleAudioProgressPanel();
      }
      this.startedRecording = false;
      this._mediaRecorder.onstop = null;
      this._stopMediaRecorder();
      this._audioContext.suspend();
      this === null || this === void 0 || (_this$stream = this.stream) === null || _this$stream === void 0 || _this$stream.getTracks().forEach(function (track) {
        track.stop();
      });
      clearTimeout(this._properStopCall);
      if (this.stopCallback) {
        this.stopCallback();
      }
      // this.isRecording = false;
    }
  }, {
    key: "isAudioConnected",
    value: function isAudioConnected() {
      if (!this._isBrowserSupportAudio() || !this.isInitialized || !this._userMediaStream) {
        return false;
      }
      var tracks = this._userMediaStream.getAudioTracks();
      return tracks && tracks.some(function (track) {
        return track.readyState === 'live';
      });
    }
  }, {
    key: "_connectNodes",
    value: function _connectNodes() {
      for (var _len = arguments.length, connectableNodes = new Array(_len), _key = 0; _key < _len; _key++) {
        connectableNodes[_key] = arguments[_key];
      }
      for (var i = 0; i < connectableNodes.length - 1; i++) {
        if (connectableNodes[i].connect) {
          connectableNodes[i].connect(connectableNodes[i + 1]);
        } else {
          throw new Error('you can not connect node');
        }
      }
    }
  }, {
    key: "_isBrowserSupportAudio",
    value: function _isBrowserSupportAudio() {
      if (!navigator.mediaDevices || !navigator.mediaDevices.getUserMedia || !window.MediaRecorder) {
        return false;
      }
      return true;
    }
  }]);
}(); //Entry 네임스페이스에는 존재하지 않으므로 외부에서 사용할 수 없다.
var _default = exports["default"] = new AudioUtils();